import { decode as base64_decode, encode as base64_encode } from "base-64";
// import RootStore from "./RootStore";
import { postApi, baseURL } from "../components/Utility";
import {
  action,
  computed,
  makeObservable,
  observable,
  autorun,
  runInAction,
} from "mobx";
// import { act } from "react-dom/test-utils";
import { message } from "antd";
import config from "../config";

class DriverLoginReportStore {
  total = 0;
  remaning_driverId = "";
  last_record_timestamp = "";
  driverLoginStore = [];
  totalDriverArray = [];
  getDrivers = [];
  pythonReportMessage = false;
  pythonReportErrorMessage = false;
  rootStore;

  constructor(rootStore) {
    makeObservable(this, {
      driverLoginStore: observable,
      remaning_driverId: observable,
      last_record_timestamp: observable,
      total: observable,
      totalDriverArray: observable,
      loadData: action,
      getDriversByCompanyId: action,
      totalDriverReport: action,
      pythonReportMessage: observable,
    });
    this.rootStore = rootStore;
  }

  async loadData({
    companyId,
    driverId,
    fromDate,
    toDate,
    offset,
    limit,
    pageNo,
  }) {
    // console.log("vehicle list");
    var postData = {
      companyId: companyId,
      driverName: driverId,
      fromDate: fromDate,
      toDate: toDate,
      offset: offset,
      limit: limit,
      page: pageNo,
    };
    this.loading = true;

    if (config.pythonReport === 1) {
      // postData.companyId=118
      // postData.driverName=[2142]
      // postData.fromDate="2023-01-01 00:00:00"
      // postData.toDate="2023-01-07 12:54:00"
      // postData.tablename = "awtltrack.fm_mt90"
      if (offset === 0) {
        postData.last_record_timestamp = "";
        postData.remaning_driverId = "";
      } else {
        postData.last_record_timestamp = this.last_record_timestamp;
        postData.remaning_driverId = this.remaning_driverId;
      }

      var response = await postApi
        .getClient("report")
        .post("/driver_report/driverLogin", postData);
      this.total = parseInt(response?.data?.data?.TotalCount);
    } else {
      const base64Input = await base64_encode(JSON.stringify(postData));
      var response = await postApi
        .getClient()
        .post("index.php?c=driver&a=driverLogin", "postData=" + base64Input);
      this.total = parseInt(response?.data?.data?.TotalCount);
    }

    if (config.pythonReport === 1) {
      this.last_record_timestamp = response?.data?.data?.last_record_timestamp;
      this.remaning_driverId = response?.data?.data?.remaning_driverId;
    }

    // console.log(response?.data?.data?.driverLoginReport);
    this.driverLoginStore = response?.data?.data?.driverLoginReport;
    this.loading = false;
  }

  async getDriversByCompanyId({ companyId }) {
    var postData = { companyId: companyId };
    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient("NodeCoreUrl")
      .get("/driver/getDriverData", { params: postData });
    console.log(response, "post");
    this.getDrivers = response?.data?.data;
    return response?.data?.data;
  }

  async totalDriverReport({ companyId, driverId, fromDate, toDate, pageNo }) {
    if (config.pythonReport !== 1) {
      this.loadingData = true;
      // console.log("vehicletotalPerformance")
      var postData = {
        companyId: companyId,
        driverName: driverId,
        fromDate: fromDate,
        toDate: toDate,
      };

      const base64Input = await base64_encode(JSON.stringify(postData));
      var response = await postApi
        .getClient()
        .post("index.php?c=driver&a=driverTotal", "postData=" + base64Input);
      this.totalDriverArray = response?.data?.data;
      // this.total = parseInt(response?.data?.data?.TotalCount);
      this.loadingData = false;
    } else {
      var postData = {
        companyId: companyId,
        driverName: driverId,
        fromDate: fromDate,
        toDate: toDate,
        pageNo: pageNo,
        total: true,
      };

      var response = await postApi
        .getClient("report")
        .post("/driver_report/driverLogin", postData);
      this.totalDriverArray = response?.data?.data?.driverLoginReport;
      this.loadingData = false;
    }
  }

  async exportExcel(getData) {
    // console.log("getData", getData);

    if (config.pythonReport === 1) {
      getData = { ...getData, language: "english" };
      // getData = { ...getData, companyId: 118 }
      // getData = { ...getData, driverName: [2142],fromDate: "2023-01-01 00:00:00", toDate: "2023-01-07 12:54:00" }
      try {
        await postApi
          .getClient("report")
          .post("/driver_report/driverLogin/download/excel", getData, {
            responseType: "blob",
          });
        this.pythonReportMessage = true;
        // await message.success(
        //   "The report will be generated shortly. You can check its status in the pending report list.",
        //   2
        // );
      } catch (error) {
        this.pythonReportErrorMessage = false;
        message.error("Failed to download the report. Please try again.");
      }
    } else {
      let lang = "english";
      window.location.href =
        baseURL +
        "index.php?c=driver&a=exportDriverLoginExcel&cid=" +
        getData.companyId +
        "&userId=" +
        getData.userId +
        "&did=" +
        getData.DriverId +
        "&fD=" +
        getData.fromDate +
        "&tD=" +
        getData.toDate +
        "&colList=" +
        getData.colList;
    }
  }
  async exportpdf(getData) {
    if (config.pythonReport === 1) {
      getData = { ...getData, language: "english" };
      // getData = { ...getData, companyId: 118 }
      // getData = { ...getData, driverName: [2142],fromDate: "2023-01-01 00:00:00", toDate: "2023-01-07 12:54:00" }
      try {
        await postApi
          .getClient("report")
          .post("/driver_report/driverLogin/download/pdf", getData, {
            responseType: "blob",
          });
        this.pythonReportMessage = true;
        // await message.success(
        //   "The report will be generated shortly. You can check its status in the pending report list.",
        //   2
        // );
      } catch (error) {
        this.pythonReportErrorMessage = false;
        message.error("Failed to download the report. Please try again.");
      }
    } else {
      let lang = "english";
      window.location.href =
        baseURL +
        "index.php?c=driver&a=exportDriverLoginPdf&cid=" +
        getData.companyId +
        "&userId=" +
        getData.userId +
        "&did=" +
        getData.DriverId +
        "&fD=" +
        getData.fromDate +
        "&tD=" +
        getData.toDate +
        "&colList=" +
        getData.colList;
    }
  }
  async exportcsv(getData) {
    window.location.href =
      baseURL +
      "index.php?c=driver&a=exportDriverLoginCsv&cid=" +
      getData.companyId +
      "&userId=" +
      getData.userId +
      "&did=" +
      getData.DriverId +
      "&fD=" +
      getData.fromDate +
      "&tD=" +
      getData.toDate +
      "&colList=" +
      getData.colList;
  }
  async exportxml(getData) {
    window.location.href =
      baseURL +
      "index.php?c=driver&a=exportDriverLoginXml&cid=" +
      getData.companyId +
      "&userId=" +
      getData.userId +
      "&did=" +
      getData.DriverId +
      "&fD=" +
      getData.fromDate +
      "&tD=" +
      getData.toDate +
      "&colList=" +
      getData.colList;
  }
}

export default DriverLoginReportStore;
